import { Controller } from 'stimulus';

export default class extends Controller {
  removeAttachment(e) {
    e.currentTarget.parentNode.remove()
  }
}
